import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

export default function RofuelPrivacy() {
  // Override the body overflow on mount to allow scrolling
  React.useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "auto";
    
    return () => {
      document.body.style.overflow = originalOverflow || "hidden";
    };
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-[#121212] to-black text-gray-300 py-12 px-6 md:px-20 font-sans">
      <div className="max-w-4xl mx-auto bg-white/5 backdrop-blur-md border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl mb-12">
        <Link 
          to="/" 
          className="inline-flex items-center space-x-2 text-[#00df9a] hover:text-emerald-400 transition-colors mb-8 group"
        >
          <FaArrowLeft className="group-hover:-translate-x-1 transition-transform" />
          <span className="font-bold">Back to Home</span>
        </Link>

        <h1 className="text-4xl md:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-[#00df9a] to-emerald-400 drop-shadow-lg mb-4">
          RoFuel Privacy Policy
        </h1>
        <p className="text-sm text-gray-400 mb-12 italic">Last Updated: March 22, 2026</p>

        <div className="space-y-8 text-lg leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4 border-b border-white/10 pb-2">1. Overview</h2>
            <p>
              The RoFuel app ("the App") is committed to protecting user privacy. This App does not require a user account or login to function. We do not collect "Personal Information" such as your name, email address, or phone number.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 border-b border-white/10 pb-2">2. Data Collection and Usage</h2>
            <p className="mb-4">
              Although we do not manually collect personal data, we use third-party services from Google (Firebase) to help us understand how the App is used and to fix technical issues.
            </p>
            <ul className="list-disc pl-6 space-y-3">
              <li>
                <strong className="text-white">Firebase Analytics:</strong> We use this to collect anonymous usage data (e.g., which buttons are clicked, how often the app is opened). This data is aggregated and does not identify you personally.
              </li>
              <li>
                <strong className="text-white">Firebase Crashlytics:</strong> This service collects anonymized crash reports and technical device information (e.g., device model, OS version) to help us fix bugs and improve stability.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 border-b border-white/10 pb-2">3. Data Storage and Third Parties</h2>
            <p>
              The data mentioned above is processed and stored by Google on our behalf. For more information on how Google handles this data, please visit: <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer" className="text-[#00df9a] hover:underline">How Google uses data when you use our partners' sites or apps</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 border-b border-white/10 pb-2">4. Opt-Out</h2>
            <p>
              You can limit the data collected by these services through your iOS device settings by going to <code className="bg-black/30 px-2 py-1 rounded text-emerald-400">Settings &gt; Privacy &gt; Tracking</code> or <code className="bg-black/30 px-2 py-1 rounded text-emerald-400">Settings &gt; Privacy &gt; Analytics &amp; Improvements</code>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4 border-b border-white/10 pb-2">5. Contact</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact <a href="mailto:mirceamartinioan@gmail.com" className="text-[#00df9a] hover:underline font-medium">mirceamartinioan@gmail.com</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}